<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Rep Load Title
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.title="{ item }">
                                <div class="text-truncate" style="max-width: 300px;">
                                    {{ item.title }}
                                </div>
                            </template>
                            <template v-slot:item.duration="{ item }">
                                <div>
                                    {{ formatDate(item.start_date) }} - {{ formatDate(item.end_date) }}
                                </div>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showRepLoadingDialog(item)" size="small" variant="outlined" text="Assiged Units" color="green-accent-4" elevation="3" class="mr-2"></v-btn>
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <RepTitleDialog ref="RepTitleDialog" @refresh="init()"/>
    <RepUnitLoadingDialog ref="RepUnitLoadingDialog" @refresh="init()" />

</template>

<script>
import axios from 'axios';
import RepTitleDialog from '../Dialogs/RepTitleDialog.vue'
import RepUnitLoadingDialog from '../Dialogs/RepUnitLoadingDialog.vue';
import { defineComponent } from 'vue'

export default defineComponent({
    components: {
        RepTitleDialog,
        RepUnitLoadingDialog
    },
    data () {
        return {
            data: [],
            search: null,
            loading: false,

            headers: [
                { title: 'Title', align: 'start', sortable: true, key: 'title' },
                { title: 'SO Number', align: 'start', sortable: true, key: 'so_number' },
                { title: 'Duration', align: 'start', sortable: true, key: 'duration' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/rep-title/findAllTitleBySemester/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.RepTitleDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.RepTitleDialog.initEdit(data)
        },
        showRepLoadingDialog(data){
            this.$refs.RepUnitLoadingDialog.init(data)
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>